import get from 'lodash/get'

export const getHintOrganisationId = (error: unknown): string | undefined => {
  const hintOrganisationId = get(error, 'detail.hintOrganisationId')
  return typeof hintOrganisationId === 'string' ? hintOrganisationId : undefined
}
